// @flow

import React from 'react';
import { connect } from 'react-redux';
import type { KeepeekPartialMedia } from '../../types/keepeekType';
import KeepeekMedia from './KeepeekMedia';
import { closeModal, openModalWithElements } from '../../state/page/pageService';

type Props = {
  medias: KeepeekPartialMedia[],
  openModalWithElements: Function,
  closeModal: Function,
  autoClassName?: boolean,
}

class KeepeekMediaCarousel extends React.PureComponent<Props> {
  render() {
    const {
      autoClassName, openModalWithElements, closeModal, medias,
    } = this.props;
    return (
      <div className={autoClassName ? 'media-container' : ''}>
        <div className="images-container">
          {
            this.props.medias
              .sort((a, b) => a.order - b.order)
              .map((media, index) => (
                <div
                  role="button"
                  tabIndex={0}
                  key={media.keepeekId}
                  onClick={() =>
                    openModalWithElements({
                      medias,
                      itemSelected: index,
                      isOpen: true,
                      isAlreadyLoaded: false,
                    })}
                >
                  <KeepeekMedia
                    keepeekId={media.keepeekId}
                    closePdfCallBack={closeModal}
                  />
                </div>
              ))
          }
        </div>
      </div>
    );
  }
}

KeepeekMediaCarousel.defaultProps = {
  autoClassName: true,
};

export default connect(
  null,
  {
    openModalWithElements,
    closeModal,
  },
)(KeepeekMediaCarousel);
